// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"5bdb384c","277":"a42e4e08","506":"5a8b5620","740":"e9f285bd"}[chunkId] + ".chunk.css";
};